requestAnimationFrame(() => {
  document.addEventListener('alpine:init', () => {
    Alpine.store('xBadges', {
      fixedPositionTemplate: `<div
        class="x-badge-{label-id} x-badge-container pointer-events-none{container-img-class} ltr"
        {preview-show-condition}
      >
        {content}
      </div>`,
      customPositionTemplate: `<div
        class="x-badge-{label-id} x-badge-container min-w-fit max-w-full max-h-full pointer-events-none{container-css-class} ltr"
        x-data="{
          contentHeight: 1,
          rePosition() {
            this.$nextTick(() => {
              this.contentHeight = this.$refs.content ? this.$refs.content.offsetHeight : contentHeight;
            });
          }
        }"
        x-intersect.once="rePosition();
          if (Shopify.designMode) {
            window.addEventListener('resize', () => {
              if ($store.xBadges.lastWindowWidth != window.innerWidth) {
                rePosition();
              }
            });
          } else {
            installMediaQueryWatcher('(min-width: 768px)', (matches) => rePosition());
          }"
        {preview-show-condition}
        :style="'{css-position} min-height: ' + contentHeight + 'px'"
      >
        {content}
      </div>`,
      productDetailTemplate: `<div
        class="x-badge-{label-id} x-badge-container min-w-fit max-w-full max-h-full bottom-0 pointer-events-none{container-css-class}{container-img-class}"
      >
        {content}
      </div>`,
      outSideImageTemplate: `<div class="hidden" 
        x-data="{
          setPosition() {
            const element = $el.closest('.card-product').getElementsByClassName('{queryEL}');
            for (let i = 0; i < element.length; i++) {
              element[i].innerHTML += $el.innerHTML;
            }
          }
        }"
        x-init="setPosition()">
        <div
          class="x-badge-{label-id} x-badge-container min-w-fit max-w-full max-h-full bottom-0 pointer-events-none{container-img-class}"
          {preview-show-condition}
        >
          {content}
        </div>
      </div>`,
      previewActiveBlock: window.xBadgesPreviewActiveBlock,
      init() {
        if (Shopify.designMode) {
          document.addEventListener('shopify:block:select', (event) => {
            if (!event.target.classList.contains('x-badges-block-preview')) return;

            let blockId = event.target.getAttribute('block-id');
            this.previewActiveBlock = blockId;
            window.xBadgesPreviewActiveBlock = blockId;
            document.dispatchEvent(new CustomEvent("eurus:badges:block-select"));
          });
        }
      },
      load(el, callback = () => {}, container = null, productCard = false) {
        if (container) el.container = container;

        const sliderEl = el.closest('[x-data-slider]');
        if (sliderEl) {
          if (!sliderEl.classList.contains('is-initialized')) {
            const sectionId = el.closest('[x-data-slider]').getAttribute('x-data-slider');
            document.addEventListener(`eurus:${sectionId}:splide-ready`, () => {
              this.doLoad(el, productCard, callback);
            });
          } else {
            this.doLoad(el, productCard, callback);
          }
        } else {
          this.doLoad(el, productCard, callback);
        }
      },
      doLoad(el, productCard, callback = () => {}) {
        this.initAllLabels(el, productCard);
        // Metafield badge'leri tüm labellar yüklendikten sonra ekle
        setTimeout(() => {
          this.initMetafieldTextBadges(el, productCard);
          this.initMetafieldBadges(el, productCard);
          this.initMetafieldCashBadges(el, productCard);
          this.initSadeceEveBadge(el, productCard);
          // this.initFastShippingBadge(el, productCard);
          this.unifyPdpContainers(el);
          this.reorderBadges(el);
        }, 100);

        if (Shopify.designMode) {
          let productData = xParseJSON(el.getAttribute('x-labels-data'));
          document.addEventListener('shopify:section:load', () => {
            if (productData && !productData.isXBadgesPreview) {
              this.initAllLabels(el, productCard);
              setTimeout(() => {
                this.initMetafieldTextBadges(el, productCard);
                this.initMetafieldBadges(el, productCard);
                this.initMetafieldCashBadges(el, productCard);
                this.initSadeceEveBadge(el, productCard);
                // this.initFastShippingBadge(el, productCard);
                this.unifyPdpContainers(el);
                this.reorderBadges(el);
              }, 100);
            }
          });
        }

        callback(el);
      },
      initAllLabels(el, productCard) {
          let productDatas = xParseJSON(el.getAttribute('x-labels-data'));
          let allLabels = document.getElementsByClassName('x-badges-block-data');

          if (!productDatas) return;
          el.xBadgesProductData = productDatas;

          if (Shopify.designMode || productCard) {
            const cardProduct = el.closest('.card-product');
            if (cardProduct) {
              let currentLabels = cardProduct.getElementsByClassName('x-badge-container');
              while (currentLabels?.length > 0) {
                currentLabels[0].remove();
              }
            }
          }

          if (productCard) {
            requestAnimationFrame(() => {
              let variantId = null;
              const variantEl = el.closest('.card-product')?.querySelector(".current-variant");

              if (variantEl) {
                const currentVariant = JSON.parse(el.closest('.card-product')?.querySelector(".current-variant")?.textContent);
                variantId = (typeof currentVariant === 'object') ? currentVariant.id : currentVariant;
              }
              
              if (variantId) {
                productDatas.forEach(productData => {
                  if (productData.variant_id === Number(variantId)) {
                    for (let i = 0;i < allLabels.length;i++) {
                      let label = xParseJSON(allLabels[i].getAttribute('x-badges-block-data'));
                      if (!label.enable && !productData.isXBadgesPreview) return;
                      
                      label.settings.icon = allLabels[i].getAttribute('x-badges-icon');
                      this.appendLabel(el, label, productData);
                    }  
                  }

                    const THRESHOLD = 65000;
                    el.querySelectorAll('.x-free-shipping-badge').forEach(b => b.remove());

                    let topLeftContainer = el.querySelector('.top-left-container');
                    if (!topLeftContainer) {
                      topLeftContainer = this.createFixedPositionContainer('top-left');
                      el.appendChild(topLeftContainer);
                    }
                    if (productData.eve_price >= THRESHOLD) {
                      topLeftContainer.insertAdjacentElement('afterbegin', this.createAutoFreeShippingBadge());
                    }
                });
                setTimeout(() => {
                  this.initMetafieldTextBadges(el, productCard);
                  this.initMetafieldBadges(el, productCard);
                }, 100);
              } else {
                for (let i = 0;i < allLabels.length;i++) {
                  let label = xParseJSON(allLabels[i].getAttribute('x-badges-block-data'));
                  if (!label.enable && !productDatas[0].isXBadgesPreview) return;
                  
                  label.settings.icon = allLabels[i].getAttribute('x-badges-icon');
                  this.appendLabel(el, label, productDatas[0]);
                }

                const THRESHOLD = 65000;
                  el.querySelectorAll('.x-free-shipping-badge').forEach(b => b.remove());

                  let topLeftContainer = el.querySelector('.top-left-container');
                  if (!topLeftContainer) {
                    topLeftContainer = this.createFixedPositionContainer('top-left');
                    el.appendChild(topLeftContainer);
                  } 
                  if (productDatas[0] && productDatas[0].eve_price >= THRESHOLD) {
                    topLeftContainer.insertAdjacentElement('afterbegin', this.createAutoFreeShippingBadge());
                  }
                setTimeout(() => {
                  this.initMetafieldTextBadges(el, productCard);
                  this.initMetafieldBadges(el, productCard);
                }, 100);
              }
            });
          } else {
            for (let i = 0;i < allLabels.length;i++) {
              let label = xParseJSON(allLabels[i].getAttribute('x-badges-block-data'));
              if (!label.enable && !productDatas.isXBadgesPreview) return;
              
              label.settings.icon = allLabels[i].getAttribute('x-badges-icon');
              this.appendLabel(el, label, productDatas);
            }  

            const THRESHOLD = 65000;
            el.querySelectorAll('.x-free-shipping-badge').forEach(b => b.remove());
            
            if (productDatas && productDatas.eve_price >= THRESHOLD) {
              if (productDatas.container === 'product-info') {
                const stack = this.getOrCreatePdpStack(el, 'top-left');
                stack.appendChild(this.createAutoFreeShippingBadge());
              } else {
                const badgeEl = this.createAutoFreeShippingBadge();
                const lastBadge = el.querySelector('.x-badge-container:last-of-type');
                if (lastBadge && lastBadge.parentElement === el) {
                  lastBadge.insertAdjacentElement('afterend', badgeEl);
                } else {
                  el.appendChild(badgeEl);
                }
              }
            }

              const topLeftContainer = el.querySelector('.top-left-container') || el.querySelector('.x-badges-container');
              if (topLeftContainer) {
                const freeShipping = topLeftContainer.querySelector('.x-free-shipping-badge');
                const bestSeller   = topLeftContainer.querySelector('.x-badge-img')?.closest('.x-badge-container');

                if (freeShipping && bestSeller) {
                  topLeftContainer.prepend(freeShipping);
                  topLeftContainer.insertBefore(bestSeller, freeShipping.nextSibling);
                }
              }
            this.unifyPdpContainers(el);
            this.reorderBadges(el);
            el.removeAttribute('x-labels-data');
          }
      },
      appendLabel(el, label, productData) {
        const host = el.container ? el.container : el; // bazen el.container kullanıyorsun
        host.querySelectorAll(`.x-badge-${label.id}`).forEach(n => n.remove());

        // PRODUCT INFO (PDP) → her şeyi tek stack’e topla
        if (productData.container == 'product-info') {
          const stack = this.getOrCreatePdpStack(el, 'top-left');
          stack.insertAdjacentHTML('beforeend', this.processTemplate(el, label, productData));
          return;
        }

        // Custom pozisyon (card dışı özel yerleşimler)
        if (label.settings.position == 'custom') {
          el.innerHTML += this.processTemplate(el, label, productData);
          return;
        }

        // Kart/diğerleri: mevcut mantığın aynısı
        let container = el.querySelector(`.${label.settings.position}-container`);
        if (!container) {
          container = this.createFixedPositionContainer(label.settings.position);
          el.appendChild(container);
        }
        container.innerHTML += this.processTemplate(el, label, productData);
      },

      createFixedPositionContainer(position) {
        let HTMLClass = `${position}-container label-container absolute gap-1 space-y-1`;
        HTMLClass += position.includes('top') ? ' top-1 flex-col' : ' bottom-1 flex-col-reverse';
        HTMLClass += position.includes('left') ? ' left-1' : ' right-1';

        container = document.createElement("div");
        container.setAttribute('class', HTMLClass);

        return container;
      },
      getOrCreatePdpStack(el, position='top-left') {
        // overlay için kökü relative yap
        const cs = getComputedStyle(el);
        if (cs.position === 'static') {
          el.style.position = 'relative';
        }
      
        let stack = el.querySelector('.pdp-badge-stack');
        if (!stack) {
          stack = document.createElement('div');
          stack.className = 'pdp-badge-stack pointer-events-none'; // tıklama geçişi
          // OVERLAY: layout'a katkı yapmasın
          stack.style.position = 'absolute';
          // top-left konum
          stack.style.top = '8px';
          stack.style.left = '8px';
          stack.style.zIndex = '60';
      
          // Üst üste binmeyi önlemek için dikey yığın
          stack.style.display = 'flex';
          stack.style.flexDirection = 'column';
          stack.style.alignItems = 'flex-start';
          stack.style.gap = '4px';
          stack.style.width = 'max-content';
      
          el.appendChild(stack);
        }
      
        // el içinde doğrudan duran badge konteynerleri stack'e taşı
        el.querySelectorAll(':scope > .x-badge-container').forEach(node => {
          if (node !== stack) stack.appendChild(node);
        });
      
        return stack;
      },
      processContent(el, label, productData) {
        let content = false;
        const canShow = this.canShow(label, productData);

        if (label.settings.image && canShow) {
          /** image label */
          let imageHeight, imageWidth;
          if (productData.container == 'product-info') {
            imageHeight = 63;
            imageWidth = Math.round(imageHeight * label.settings.image_aspect_ratio);
          } else {
            imageWidth = label.settings.size_mobile > label.settings.size ? label.settings.size_mobile * 15 : label.settings.size * 15;
            imageHeight = imageWidth / label.settings.image_aspect_ratio;
          }
          let image;
          if (label.settings.image.src) {
            image = label.settings.image.src.includes('burst.shopifycdn.com') ? label.settings.image.src : 
            label.settings.image.src + `&width=` + (imageWidth * 3);
          } else {
            image = label.settings.image.includes('burst.shopifycdn.com') ? label.settings.image : 
            label.settings.image + `&width=` + (imageWidth * 3);
          }
          if (productData.container == "card") {
            var imageDirection = label.settings.position.includes('left') ? "justify-start" : "justify-end";
            var styleImage = 'width: var(--width-image-label); height: var(--height-image-label)';
          } else {
            var imageDirection = productData.make_content_center ? "justify-center" : "justify-start";
            var styleImage = '';
          }
          content = `<div x-ref="content" class='x-badge-content flex ${imageDirection}{css-opacity}'>
            <img 
              loading="lazy"
              width="` + imageWidth + `"
              height="` + imageHeight + `"
              alt="` + (label.settings.image_alt.length > 0 ? label.settings.image_alt : productData.title) + `"
              src="` + image + `"
              style="${styleImage}"
            />
          </div>`;
        } else if (label.settings.content && canShow) {
          /** text label */
          let qty = (productData.inventory_management.length < 1 || productData.qty < 0) ? '' : productData.qty;
          let saleAmount = productData.sale_amount.includes('-') ? '' : productData.sale_amount;
          let countDown = label.settings.schedule_enabled ? '<span x-intersect.once="$nextTick(() => { if (typeof rePosition !== `undefined`) {rePosition()} });" class="x-badge-countdown-' + label.id + ' label-countdown empty:hidden"></span>' : '';
          let sale = Math.round((productData.compare_at_price - productData.price) * 100 / productData.compare_at_price);
          sale = sale == 100 ? 99 : sale;
          sale = sale > 0 ? sale + '%' : '';

          content = label.settings.content.replace(/{sale}/gi, sale)
                      .replace(/{sale_amount}/gi, saleAmount)
                      .replace(/{qty}/gi, qty)
                      .replace(/{price}/gi, productData.price_with_currency)
                      .replace(/{count_down}/gi, countDown);

          if (productData.metafield_label) {
            Object.entries(productData.metafield_label).forEach(([key, value]) => {
              content = content.replace(`{${key}}`, value);
            });
          }
          const padding = label.settings.size / 2;
          const padding_mobile = label.settings.size_mobile / 2;
          const sizeClass = productData.container == 'product-info' ? '' : ` pt-${padding_mobile} pb-${padding_mobile} pl-${padding_mobile + 1.5} pr-${padding_mobile + 1.5} md:pt-${padding} md:pb-${padding} md:pl-${padding + 1.5} md:pr-${padding + 1.5}`;
          const inlineStyle = productData.container == 'product-info' ? '' : `style="font-size: var(--font-size-scale);"`;
          const inlineStyleIcon = productData.container == 'product-info' ? '' : `style="height: var(--font-size-scale); width: var(--font-size-scale); min-width: var(--font-size-scale);"`;
          const hasIcon = label?.settings?.icon && label.settings.icon.trim() !== '';

          const isMobile = typeof window !== 'undefined' && window.matchMedia('(max-width: 640px)').matches;
          const sizeCard = isMobile ? { h:44, w:44 } : { h:56, w:56 };
          const sizeFull = isMobile ? { h:64, w:64 } : { h:84, w:84 };
          const {h,w} = productData.container === 'card' ? sizeCard : sizeFull;

          const customImg = `
            <img src="https://cdn.shopify.com/s/files/1/0701/3852/7882/files/big-100x100px.png?v=1758610621"
                alt="Çok Satan" class="x-badge-img" loading="lazy" decoding="async"
                style="height:${h}px; width:${w}px; display:inline-block; vertical-align:middle;">
            <img src="https://cdn.shopify.com/s/files/1/0701/3852/7882/files/big-thumbnail_hadi-100x100_ea216259-7a92-48d9-a614-94ba7daf3d0b.png?v=1760013590"
                alt="Çok Satan" class="x-badge-img" loading="lazy" decoding="async"
                style="height:${h}px; width:${w}px; display:inline-block; vertical-align:middle;">
          `;

let innerContent;
let hasImg = false;

if (content.trim() === "Çok Satan") {
  innerContent = customImg;
  hasImg = true;
} else {
  innerContent = `<span class="leading-normal w-fit p-break-words" style="white-space:nowrap; font-size: 0.7rem;">${content}</span>`;
}

const extraClass = hasImg ? "" : " x-badge-text";

content = content.length > 0
  ? `<div
      x-ref="content"
      class='x-badge-content ltr select-none inline-flex justify-center${sizeClass} items-center{css-opacity}{css-type} gap-2${extraClass}'
      style="white-space:nowrap; flex-direction: column;"
      ${inlineStyle}
    >
      ${
        hasIcon
          ? `<span class="icon-label hp-empty:hidden" ${inlineStyleIcon}>${label.settings.icon}</span>`
          : ''
      }
      ${innerContent}
    </div>`
  : false;

          if (countDown.length > 0 && label.settings.schedule_enabled) {
            Alpine.store('xHelper').countdown(label.settings, function(canShow, seconds, minutes, hours, days) {
              let container = el.container ? el.container : el;
              const countdownElements = container.getElementsByClassName('x-badge-countdown-' + label.id);

              if (!canShow) {
                for (let i = 0;i < countdownElements.length;i++) {
                  countdownElements[i].innerHTML = '';
                }

                return;
              }

              days = days > 0 ? days + "D&nbsp;&nbsp;&nbsp;" : "";
              hours = hours == 0 && days.length == 0 ? "" : hours + " : ";
              const timeLeft = days + hours + minutes + " : " + seconds;

              for (let i = 0;i < countdownElements.length;i++) {
                countdownElements[i].innerHTML = timeLeft;
              }
            });
          }
        }

        return content;
      },
      processTemplate(el, label, productData) {
        let template = '';
        if (content = this.processContent(el, label, productData)) {
          const cssOpacity = " opacity-" + label.settings.opacity;
          const cssPosition = productData.container == "card" ? "left: " + label.settings.horizontal_position + "%;" + " transform: translate(-"+ label.settings.horizontal_position+"%, -"+ label.settings.vertical_position+"%);"
                            + " top: " + (label.settings.vertical_position) + "%;"
                            : "";
          let cssType = '';
          if (label.settings.type == 'round') cssType = ' rounded-md';
          if (label.settings.type == 'rounded-full') cssType = ' rounded-full';

          let containerCssClass = productData.container == "card" ? " absolute w-max" : "";
          containerCssClass += label.settings.horizontal_position > 50 ? " text-end" : " text-start";
          const previewShowCondition = productData.isXBadgesPreview ? `x-show="$store.xBadges.previewActiveBlock == '{label-id}'"` : '';
          const imgClass = label.settings.image ? ' label-img' : '';

          template = this.getLableTemplate(productData.container, label.settings.position);
          template = template.replace('{preview-show-condition}', previewShowCondition)
            .replace('{content}', content)
            .replace('{css-opacity}', cssOpacity)
            .replace('{css-position}', cssPosition)
            .replace('{css-type}', cssType)
            .replace('{container-css-class}', containerCssClass)
            .replace('{container-img-class}', imgClass)
            .replace(/{label-id}/gi, label.id);
        }
        return template;
      },
      getLableTemplate(container, position) {
        if (container == 'product-info') {
          return this.productDetailTemplate;
        } else if (position == 'custom') {
          return this.customPositionTemplate;
        } else if (position == 'below-image' || position == 'bottom-card' || position == 'next-price') {
          return this.outSideImageTemplate.replace('{queryEL}', position);
        }

        return this.fixedPositionTemplate;
      },
      canShow(label, productData) {

        if (productData.isXBadgesPreview) {
          return true;
        }

        if (productData.container == 'card' && !label.settings.show_on_product_card) {
          return false;
        }
        if (productData.container == 'product-info' && !label.settings.show_on_product_page) {
          return false;
        }

        if (label.type == "sale-label" && productData.compare_at_price > productData.price) {
          return true;
        }
        if (label.type == "sold-out-label") {
          // HP: 0 stok + düşük stok (<= eşik) için Tükendi badge göster
          var HP_SOLDOUT_THRESHOLD = 3;
          var hpLowStock =
            !productData.can_show_preorder &&
            typeof productData.inventory_management === 'string' &&
            productData.inventory_management.length > 0 &&
            productData.inventory_policy !== 'continue' &&
            productData.qty >= 0 &&
            productData.qty <= HP_SOLDOUT_THRESHOLD;
          // EVS-36: Ürün genelinde değerlendir; tek beden/renk bitince değil, tüm varyantlar bitince göster.
          if (typeof productData.hp_all_soldout === 'boolean') {
            return productData.hp_all_soldout;
          }
          if (!productData.available || hpLowStock) {
            return true;
          }
        }
        if (label.type == "preorder-label") {
          if (productData.can_show_preorder && productData.available) {
            return true;
          } else {
            return false;
          }
        }

        if (label.settings.schedule_enabled) {
          let endDate = new Date(
            label.settings.end_year,
            label.settings.end_month - 1,
            label.settings.end_day,
            label.settings.end_hour,
            label.settings.end_minute
          );
          label.endTime =
            endDate.getTime() +
            (-1 * label.settings.timezone * 60 - endDate.getTimezoneOffset()) *
              60 *
              1000;

          let startDate = new Date(
            label.settings.start_year,
            label.settings.start_month - 1,
            label.settings.start_day,
            label.settings.start_hour,
            label.settings.start_minute
          );
          label.startTime =
            startDate.getTime() +
            (-1 * label.settings.timezone * 60 - startDate.getTimezoneOffset()) *
              60 *
              1000;

          let now = new Date().getTime();
          if (label.endTime < now) {
            return false;
          }

          if (label.startTime > now) {
            return false;
          }
        }

        if (label.settings.applied_products.includes(productData.product_id)) {
          return true;
        }

        for (let i = 0; i < label.settings.applied_collections.length; i++) {
          if (productData.collections.includes(label.settings.applied_collections[i])) {
            return true;
          }
        }

        if (
          label.type != "sale-label" &&
          label.type != "sold-out-label" &&
          label.settings.applied_products.length == 0 &&
          label.settings.applied_collections.length == 0
        ) {
          return true;
        }

        return false;
      },
      initMetafieldTextBadges(el, productCard) {
        const cardProduct = el.closest('.card-product');
        let textBadges;

        if (cardProduct) {
          const metafieldContainer = cardProduct.querySelector('.custom-metafield-text-badges');

          if (!metafieldContainer) return;

          const metafieldTextData = metafieldContainer.getAttribute('data-metafield-text-badges');

          if (!metafieldTextData || metafieldTextData === 'null' || metafieldTextData === '' || metafieldTextData.trim() === '') return;

          try {
            textBadges = JSON.parse(metafieldTextData);
          } catch (e) {
            console.warn('Metafield text badge data parse edilemedi:', e);
            return;
          }
        } else {
          const productData = el.xBadgesProductData || xParseJSON(el.getAttribute('x-labels-data'));
          textBadges = productData?.metafield_text_badges;
        }

        if (!textBadges) return;
        if (!Array.isArray(textBadges)) {
          textBadges = [textBadges];
        }
        if (textBadges.length === 0) return;

        const existingTextBadges = el.querySelectorAll('.x-metafield-text-badge');
        existingTextBadges.forEach(badge => badge.remove());

        let topLeftContainer = el.querySelector('.top-left-container');
        if (!topLeftContainer) {
          topLeftContainer = (el.closest('.product') || el).querySelector('.pdp-badge-stack') 
                             || this.getOrCreatePdpStack(el, 'top-left');
        }

        textBadges.forEach((badgeData, index) => {
          const badgeElement = this.createMetafieldTextBadge(badgeData, index);
          if (badgeElement) {
            topLeftContainer.appendChild(badgeElement);
          }
        });

        this.reorderBadges(el);
      },
      initMetafieldCashBadges(el, productCard) {
        const cardProduct = el.closest('.card-product');
        let cashBadgeText;

        if (cardProduct) {
          const metafieldContainer = cardProduct.querySelector('.custom-metafield-cash-badges');

          if (!metafieldContainer) return;

          const metafieldCashData = metafieldContainer.getAttribute('data-metafield-cash-badge');

          if (!metafieldCashData || metafieldCashData === 'null' || metafieldCashData === '' || metafieldCashData.trim() === '') return;

          try {
            cashBadgeText = JSON.parse(metafieldCashData);
          } catch (e) {
            console.warn('Metafield cash badge data parse edilemedi:', e);
            return;
          }
        } else {
          const productData = el.xBadgesProductData || xParseJSON(el.getAttribute('x-labels-data'));
          cashBadgeText = productData?.metafield_cash_badge;
        }
        if (!cashBadgeText || cashBadgeText.trim() === '') return;


        const existingCashBadges = el.querySelectorAll('.x-metafield-cash-badge');
        existingCashBadges.forEach(badge => badge.remove());

        let topLeftContainer = el.querySelector('.top-left-container');
        if (!topLeftContainer) {
          topLeftContainer = cardProduct
            ? this.createFixedPositionContainer('top-left')
            : this.getOrCreatePdpStack(el, 'top-left');

          if (cardProduct) {
            el.appendChild(topLeftContainer);
          }
        }

        const badgeElement = this.createMetafieldCashBadge(cashBadgeText);
        topLeftContainer.appendChild(badgeElement);
        this.reorderBadges(el);
      },
      initSadeceEveBadge(el, productCard) {
        if (productCard) return;

        el.querySelectorAll('.x-metafield-sadece-eve-badge').forEach(badge => badge.remove());

        const productData = el.xBadgesProductData || xParseJSON(el.getAttribute('x-labels-data'));
        if (!productData || !productData.show_sadece_eve_badge) return;

        const topLeftContainer = this.getOrCreatePdpStack(el, 'top-left');
        const badgeElement = this.createMetafieldTextBadge({
          text: "Sadece Eve'de",
          backgroundColor: '#E91E63',
          textColor: '#FFFFFF',
          badgeClass: 'x-metafield-sadece-eve-badge',
        });

        if (badgeElement) {
          topLeftContainer.appendChild(badgeElement);
        }
      },
      initMetafieldBadges(el, productCard) {
        const cardProduct = el.closest('.card-product');
        let metafieldImageUrls = [];

        if (cardProduct) {
          const metafieldContainer = cardProduct.querySelector('.custom-metafield-badges');

          if (!metafieldContainer) return;

          const metafieldImageUrl = metafieldContainer.getAttribute('data-metafield-badges');

          if (!metafieldImageUrl || metafieldImageUrl === 'null' || metafieldImageUrl === '' || metafieldImageUrl.trim() === '') return;

          metafieldImageUrls = [metafieldImageUrl];
        } else {
          const productData = el.xBadgesProductData || xParseJSON(el.getAttribute('x-labels-data'));
          metafieldImageUrls = Array.isArray(productData?.metafield_image_badges)
            ? productData.metafield_image_badges.filter((url) => typeof url === 'string' && url.trim() !== '')
            : [];
          if (!metafieldImageUrls.length) return;
        }

        const existingMetafieldBadges = el.querySelectorAll('.x-metafield-badge');
        existingMetafieldBadges.forEach(badge => badge.remove());

        let topLeftContainer = el.querySelector('.top-left-container');
        if (!topLeftContainer) {
          topLeftContainer = cardProduct
            ? this.createFixedPositionContainer('top-left')
            : this.getOrCreatePdpStack(el, 'top-left');
          if (cardProduct) {
            el.appendChild(topLeftContainer);
          }
        }

        metafieldImageUrls.forEach((imageUrl) => {
          const badgeElement = this.createMetafieldBadge(imageUrl);
          topLeftContainer.appendChild(badgeElement);
        });

        this.reorderBadges(el);
      },
      createMetafieldBadge(imageUrl) {
        const badge = document.createElement('div');
        badge.className = 'x-metafield-badge x-hp-custom-badge x-badge-container pointer-events-none label-img';
        

        const imageWidth = 75; 
        const imageHeight = 75; 

        const img = document.createElement('img');
        img.src = imageUrl.replace('width=75', 'width=150');
        img.alt = 'Product Badge';
        img.width = imageWidth;
        img.height = imageHeight;
        img.loading = 'lazy';
        img.style.cssText = 'width: var(--width-image-label, ' + imageWidth + 'px); height: var(--height-image-label, auto); object-fit: contain;';

        const content = document.createElement('div');
        content.className = 'x-badge-content flex justify-start';
        content.appendChild(img);

        badge.appendChild(content);
        return badge;
      },

      createAutoFreeShippingBadge() {
        const badge = document.createElement('div');
        badge.className = 'x-free-shipping-badge x-hp-custom-badge x-badge-container pointer-events-none ltr';
      
        const content = document.createElement('div');
        content.className = 'x-badge-content ltr x-badge-text select-none inline-flex justify-center items-center opacity-100 rounded-full gap-2';
        content.style.cssText = 'background-color:#28A745;color:#FFFFFF;font-size:0.7rem;padding:.25rem .625rem; width: max-content;';
      
        const textSpan = document.createElement('span');
        textSpan.className = 'leading-normal w-fit p-break-words';
        textSpan.textContent = 'Kargo Bedava';
      
        content.appendChild(textSpan);
        badge.appendChild(content);
        return badge;
      },

      normalizeMetafieldTextBadge(badgeData) {
        if (typeof badgeData === 'string') {
          const text = badgeData.trim();
          return text ? { text } : null;
        }

        if (!badgeData || typeof badgeData !== 'object') {
          return null;
        }

        const text = typeof badgeData.text === 'string' ? badgeData.text.trim() : '';
        if (!text) {
          return null;
        }

        return {
          text,
          backgroundColor: typeof badgeData.backgroundColor === 'string' ? badgeData.backgroundColor.trim() : '',
          textColor: typeof badgeData.textColor === 'string' ? badgeData.textColor.trim() : '',
          badgeClass: typeof badgeData.badgeClass === 'string' ? badgeData.badgeClass.trim() : '',
        };
      },
      createMetafieldTextBadge(badgeData, index) {
        const normalizedBadge = this.normalizeMetafieldTextBadge(badgeData);
        if (!normalizedBadge) return null;

        const badge = document.createElement('div');
        badge.className = `x-metafield-text-badge x-hp-custom-badge x-badge-container pointer-events-none ltr ${normalizedBadge.badgeClass || ''}`.trim();
        
        const content = document.createElement('div');
        content.className = 'x-badge-content ltr x-badge-text select-none inline-flex justify-center pt-1 pb-1 pl-2.5 pr-2.5 md:pt-1 md:pb-1 md:pl-2.5 md:pr-2.5 items-center opacity-100 rounded-full gap-2 hp-bg-eveorange hp-text-black !hp-text-[11.2px] m:!hp-text-[9.6px]';
        const contentStyles = ['font-size: var(--font-size-scale)'];
        if (normalizedBadge.backgroundColor) {
          contentStyles.push(`background-color: ${normalizedBadge.backgroundColor}`);
        }
        if (normalizedBadge.textColor) {
          contentStyles.push(`color: ${normalizedBadge.textColor}`);
        }
        content.style.cssText = `${contentStyles.join('; ')};`;
        content.setAttribute('x-ref', 'content');
        
        const textSpan = document.createElement('span');
        textSpan.className = 'leading-normal w-fit p-break-words';
        textSpan.textContent = normalizedBadge.text;
        
        content.appendChild(textSpan);
        badge.appendChild(content);
        return badge;
      },
      createMetafieldCashBadge(cashValue) {
        const badge = document.createElement('div');
        badge.className = 'x-metafield-cash-badge x-hp-custom-badge x-badge-container pointer-events-none ltr';
        
        const content = document.createElement('div');
        content.className = 'x-badge-content ltr x-badge-text select-none inline-flex justify-center pt-1 pb-1 pl-2.5 pr-2.5 md:pt-1 md:pb-1 md:pl-2.5 md:pr-2.5 items-center opacity-100 rounded-full gap-2 hp-bg-eveorange hp-text-black !hp-text-[11.2px] m:!hp-text-[9.6px]';
        content.style.cssText = 'font-size: var(--font-size-scale);';
        content.setAttribute('x-ref', 'content');
        
        const textSpan = document.createElement('span');
        textSpan.className = 'leading-normal w-fit p-break-words';
        textSpan.textContent = `30 TL ve Üzeri ${cashValue}`;
        
        content.appendChild(textSpan);
        badge.appendChild(content);
        return badge;
      },
reorderBadges(el) {
  const host = el.closest('.card-product') || el;

  let container =
    host.querySelector('.top-left-container') ||
    host.querySelector('.x-badges-container') ||
    host.querySelector('.label-container') ||
    el.querySelector('.pdp-badge-stack') ||
    el.querySelector('.top-left-container') ||
    el.querySelector('.x-badges-container') ||
    el;

  if (!container) return;

  // stack görünümü (ürün kartı için)
  container.style.display = 'flex';
  container.style.flexDirection = 'column';
  container.style.alignItems = 'flex-start';
  container.style.gap = container.style.gap || '4px';
  container.style.width = container.style.width || 'max-content';
  container.style.zIndex = container.style.zIndex || '60';

  const norm = (s) =>
    (s || '')
      .toString()
      .trim()
      .toLocaleLowerCase('tr-TR')
      .replace(/\s+/g, ' ');

  const nodes = Array.from(container.children).filter((n) =>
    n.classList?.contains('x-badge-container')
  );
  if (!nodes.length) return;

  const isImageBadge = (node) => {
    if (node.classList.contains('label-img')) return true;          // image label
    if (node.classList.contains('x-metafield-badge')) return true;  // metafield image
    if (node.querySelector('.x-badge-img')) return true;            // "Çok Satan" custom img
    return false;
  };

  const getText = (node) => norm(node.textContent || '');

  const findBadge = (fn) => nodes.find((n) => fn(getText(n), n)) || null;

  const cashBadge = container.querySelector('.x-metafield-cash-badge');

  // ✅ "İkinci Ürün %50" / "2. Ürün %10" vs. hepsini yakala
  const secondDealBadge = findBadge((t) => {
    const hasSecond =
      t.includes('2. ürün') ||
      t.includes('2. urun') ||
      t.includes('ikinci ürün') ||
      t.includes('ikinci urun') ||
      t.includes('2. ürüne') ||
      t.includes('2. urune');
    const hasPercent = t.includes('%') || t.includes('percent');
    return hasSecond && hasPercent;
  });

  const tukendiBadge = findBadge((t) =>
    t.includes('tükendi') || t.includes('tukendi')
  );

  const yeniBadge = findBadge((t) => t === 'yeni' || t.includes('yeni'));

  const picked = new Set();
  const order = [];

  const pushIf = (n) => {
    if (n && !picked.has(n) && n.parentElement === container) {
      picked.add(n);
      order.push(n);
    }
  };

  const getTextLength = (node) => getText(node).length;
  const getPriority = (node) => {
    if (node === cashBadge) return 0;
    if (node === secondDealBadge) return 1;
    if (node === tukendiBadge) return 2;
    if (node === yeniBadge) return 3;
    return 10;
  };

  const textBadges = nodes
    .filter((n) => !isImageBadge(n))
    .map((node, index) => ({
      node,
      index,
      textLength: getTextLength(node),
      priority: getPriority(node),
    }))
    .sort((a, b) => {
      if (b.textLength !== a.textLength) return b.textLength - a.textLength;
      if (a.priority !== b.priority) return a.priority - b.priority;
      return a.index - b.index;
    });

  textBadges.forEach(({ node }) => pushIf(node));

  // en altta: tüm GÖRSEL badge'ler
  nodes.forEach((n) => {
    if (!picked.has(n) && isImageBadge(n)) pushIf(n);
  });

  // yeniden sırala
  order.forEach((n) => container.appendChild(n));
},
      unifyPdpContainers(el) {
        const stack = this.getOrCreatePdpStack(el, 'top-left');
      
        el.querySelectorAll('.top-left-container, .x-badges-container, .label-container').forEach(c => {
          if (c === stack) return;
      
          c.querySelectorAll(':scope > .x-badge-container').forEach(n => {
            n.style.position = 'static';
            n.style.margin = '0';
      
            stack.appendChild(n);
          });
      
          if (c !== stack && c.childElementCount === 0) c.remove();
        });
      },
      // initFastShippingBadge(el, productCard) {
      //   // --- METAFIELD KONTROLÜ (ileride açacaksın) ---
      //   // const cardProduct = el.closest('.card-product') || document;
      //   // const mf = cardProduct.querySelector('.custom-metafield-fast-shipping');
      //   // if (!mf) return;
      //   // const enabled = mf.getAttribute('data-fast-shipping-enabled');
      //   // if (!(enabled && (enabled === 'true' || enabled === '1'))) return;

      //   // Önce eskisini temizle
      //   const containerEl = el.container ? el.container : el;
      //   containerEl.querySelectorAll('.x-fast-shipping-badge').forEach(b => b.remove());

      //   if (!productCard) {
      //     const badgeEl = this.createFastShippingBadge();
      //     const lastBadge = el.querySelector('.x-badge-container:last-of-type');

      //     if (lastBadge && lastBadge.parentElement === el) {
      //       lastBadge.insertAdjacentElement('afterend', badgeEl);
      //     } else {
      //       el.appendChild(badgeEl);
      //     }
      //   } else {
      //     let topLeftContainer = containerEl.querySelector('.top-left-container');
      //     if (!topLeftContainer) {
      //       topLeftContainer = this.createFixedPositionContainer('top-left');
      //       containerEl.appendChild(topLeftContainer);
      //     }
      //     const badgeEl = this.createFastShippingBadge();
      //     topLeftContainer.appendChild(badgeEl);
      //   }
      // },

      // createFastShippingBadge() {
      //   const badge = document.createElement('div');
      //   badge.className = 'x-fast-shipping-badge x-hp-custom-badge x-badge-container pointer-events-none ltr';

      //   const content = document.createElement('div');
      //   content.className = 'x-badge-content ltr x-badge-text select-none inline-flex justify-center items-center opacity-100 rounded-full gap-2';
      //   content.style.cssText = [
      //     'background-color:#28A745',
      //     'color:#FFFFFF',
      //     'font-size:0.7rem',
      //     'padding:.25rem .625rem',
      //     'width:max-content'
      //   ].join(';');

      //   const textSpan = document.createElement('span');
      //   textSpan.className = 'leading-normal w-fit p-break-words';
      //   textSpan.textContent = '24 Saatte Kargo';

      //   content.appendChild(textSpan);
      //   badge.appendChild(content);
      //   return badge;
      // },

    });
  });
});
